import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { api, setAuthToken } from "../lib/api";

/**
 * Handles return-from-Google flow.
 * URL hash will contain: #session_id=xyz
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
    const { setUser } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash;
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/dang-nhap", { replace: true });
            return;
        }
        const sessionId = m[1];

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                if (data.access_token) setAuthToken(data.access_token);
                setUser(data);
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/cuoc-thi", { replace: true });
            } catch (e) {
                setError("Đăng nhập Google thất bại. Vui lòng thử lại.");
            }
        })();
    }, [navigate, setUser]);

    return (
        <main className="pt-24 min-h-screen flex items-center justify-center">
            <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full border-2 border-[var(--gold)] border-t-transparent animate-spin" />
                <p className="text-[var(--gold-deep)] text-sm uppercase tracking-widest">{error || "Đang xác thực Google…"}</p>
            </div>
        </main>
    );
}
